module.exports = __webpack_public_path__ + "static/media/sexy.88888938.png";